<template>
    <div>
    <!-- <div   v-for="(file, index) in attachedFiles" :key="index" class="file-item" style="display: inline-block;">
        <img v-if="isImageFile(file.accessPath)" :src="file.accessPath" alt="预览图片" style="width: 100px;cursor: pointer;"  @click="previewFile(file)"/>
        
        <a v-else
            :key="index"
            :download="file.fileName ||  file.sourceFileName"
            :href="file.accessPath"
            target="_blank"
            class="file-box"
        >
            <div    class="file-box" style="width: 20px;height: 20px;display: flex;justify-content: center;align-items: center;border: 1px solid #DCDFE6;cursor: pointer;">
            <img :src="getTypePng(file)"  :alt="file.fileName">
            </div>
        </a>
        <el-button
            icon="el-icon-close"
            class="delete-file-btn"
            size="mini"
            @click="removeFile(index,file)"
        ></el-button>
      </div> -->


      <div v-for="(file, idx) in attachedFileList" :key="idx" class="file-box">
        <div style="display: flex;gap: 5px;margin-right: 5px;">
          <img v-if="isImageFile(file.accessPath)" :src="showUrl(file.accessPath)" style="width: 20px;max-height: 20px;cursor: pointer;"    @click.prevent="previewFile(file)" :name="file.sourceFileName">
          </img>

          <a v-else
            :key="idx"
            :download="file.fileName ||  file.sourceFileName"
            
          >
            <div style="width: 20px;height: 20px;display: flex;justify-content: center;align-items: center;border: 1px solid #DCDFE6;" @click="previewData(file)">
              <img style="width: 20px;height: 20px;" :src="getTypePng(file)"  :alt="file.fileName">
            </div>
          </a>
          <span class="file-name"  :title="file.sourceFileName" @click="previewData(file)">{{file.sourceFileName}} </span>
        </div>
        <div class="btn-row" >
          <i class="el-icon-download" style="float: right;cursor: pointer;" v-if="file.accessPath || file.url" @click="downloadFile(file)"></i>
          <i v-if="needDelete" class="el-icon-delete" style="float: right;cursor: pointer;" @click="removeFile(idx,file)"></i>
        </div>
      </div>
    </div>
</template>
  
  <script>
  import {crossOriginDownload } from '@/assets/common/common.js'
  import Cookies from 'js-cookie'
  export default {
    name:"fileListShow",
    props: {
     attachedFileList: { //传入的附件
        type: Array,
        default: ()=> []
      },

      needDelete: { //是否显示删除按钮
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        crossOriginDownload,
      }
    },
    watch: {
        
    },
    methods: {

        showUrl(url){
          if(url.indexOf(this.global.BASE_URL)< 0){
            return this.global.BASE_URL + url
          }else{
            return url
          }
        },
        //判断是否是图片文件
        isImageFile(filePath) {
            if (!filePath) return false;

            // 提取扩展名（兼容带查询参数的情况，如 "image.jpg?token=123"）
            const extension = filePath
                .split('?')[0]  // 去除查询参数
                .split('.')
                .pop()
                .toLowerCase();

            // 常见图片扩展名
            const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp', 'ico'];
            return imageExtensions.includes(extension);
        },

        //通过类型获取前缀图标
        getTypePng(file){
            let filePath = file.accessPath || file.url
            if (!filePath) return require('@/assets/images/fileType/xls.png');

            // 提取扩展名（兼容带查询参数的情况，如 "image.jpg?token=123"）
            const extension = filePath
                .split('?')[0]  // 去除查询参数
                .split('.')
                .pop()
                .toLowerCase();

            if(extension == 'txt'){
            return require('@/assets/images/fileType/txt.png');
            }else if(extension == 'xls' || extension == 'xlsx'){
            return require('@/assets/images/fileType/xls.png');
            }else if(extension == 'doc'){
            return require('@/assets/images/fileType/doc.png');
            }else if(extension == 'docx'){
            return require('@/assets/images/fileType/doc.png');
            }else if(extension == 'pdf'){
            return require('@/assets/images/fileType/pdf.png');
            }else{
            return require('@/assets/images/fileType/xls.png');
            }
        },

        //图片预览
        previewFile(file){
            // this.filePreviewVisible = true;
            // this.previewFileUrl = file.accessPath;
            if (!file || !file.accessPath) {
                this.$message.warning('文件路径无效，无法预览');
                return;
            }
            // 打开新页面显示文件
            window.open(file.accessPath, '_blank');

        },

        previewData(file){
          window.open(this.global.FILE_PRE+'?&baseUrl='+this.global.BASE_URL+'&url='+this.global.BASE_URL+file.accessPath+'&token='+Cookies.get(`token_${window.location.port}`), '_blank')
        },

        //删除文件（仅仅组件内的显示，实际删除需要返回remove事件去处理）
        removeFile(index,file) {
            this.attachedFileList.splice(index, 1); // 移除指定文件
            // this.$refs.fileUpload.removeItem(file)
            console.log(file,'file')
            this.$emit('removeFile',index,file)
        },
        //文件下载
        downloadFile(file){
            let url = file.accessPath || file.url
            let fileName = file.name || file.sourceFileName
            this.crossOriginDownload(file.accessPath,fileName)
        },



    },
    mounted () {

        

    }
  }
  </script>
  <style lang="scss" scoped>

  .file-box{
  padding: 5px;
  border: 1px solid #DCDFE6;
  border-radius: 2px;
  color: #33383D;
  background:rgb(250,248,247);

  max-width: 230px;
  min-width: 104px;
  margin-right: 4px;
  margin-bottom: 4px;

  display: flex;
  justify-content: space-between;
  align-items: center;
  /* margin: 5px; */
}
.file-name{
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;
  max-width: 160px;
  line-height: 20px;
  color: #3d3533;
  font-size: 12px;
}
.file-box:hover{
  /* background-color: rgba(255, 157, 138, 0.2)!important; */
}
.btn-row{
    display: flex;
    padding-left: 5px;
    border-left: 1px solid #f0f1f2;
    justify-content: center;
    flex-direction: row;
    gap:8px;
    min-width: 20px;
}
  </style>
  


// WEBPACK FOOTER //
// src/components/fileListShow.vue